function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import React, { useState } from 'react';
import { Box, Typography, Collapse, Input } from '@applyboard/ui-components';
import { ChevronDownOutlineIcon } from '@applyboard/ui-icons';
import { CollapsibleButton } from "./style";
var format = function format(value) {
  var _ref;
  return (_ref = "".concat(value)) === null || _ref === void 0 ? void 0 : _ref.replace(/_/g, ' ');
};
var formatOperator = function formatOperator(op) {
  switch (op) {
    case 'equal':
      return '= (Equal)';
    case 'gt':
      return '> (Greater than)';
    case 'lt':
      return '< (Lower than)';
    default:
      return op;
  }
};
var ConditionClauseEntry = function ConditionClauseEntry(_ref2) {
  var item = _ref2.item;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Input, {
    inputProps: {
      readOnly: true,
      'aria-readonly': true
    },
    value: format(item.resource)
  }), /*#__PURE__*/React.createElement(Input, {
    inputProps: {
      readOnly: true,
      'aria-readonly': true
    },
    value: format(item.attribute)
  }), /*#__PURE__*/React.createElement(Input, {
    inputProps: {
      readOnly: true,
      'aria-readonly': true
    },
    value: formatOperator(item.operator)
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, (Array.isArray(item.operand) ? item.operand : [item.operand]).map(function (operand) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      React.createElement(Input, {
        inputProps: {
          readOnly: true,
          'aria-readonly': true
        },
        value: format(operand)
      })
    );
  })));
};
var ConditionGroupEntry = function ConditionGroupEntry(_ref3) {
  var item = _ref3.item;
  if (!item.relation) return /*#__PURE__*/React.createElement(ConditionClauseEntry, {
    item: item
  });
  return /*#__PURE__*/React.createElement(Box, null, item.relation === 'and' && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "All clauses in this group must be satisfied"), item.clauses.map(function (co, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConditionGroupEntry, {
      key: index,
      item: co
    }), item.clauses.length > 1 && item.relation === 'or' ? /*#__PURE__*/React.createElement(Typography, {
      my: 1
    }, item.relation) : null);
  }));
};
export var RequirementCondition = function RequirementCondition(_ref4) {
  var condition = _ref4.condition;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(Box, {
    mb: 1
  }, /*#__PURE__*/React.createElement(CollapsibleButton, {
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    "aria-expanded": isOpen,
    "aria-label": "show more",
    size: "small",
    variant: "text",
    endIcon: /*#__PURE__*/React.createElement(ChevronDownOutlineIcon, null),
    isExpanded: isOpen,
    mb: 1
  }, "Condition ", condition.id, ": ", condition.title), /*#__PURE__*/React.createElement(Collapse, {
    "in": isOpen,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Box, {
    m: 1
  }, condition.conditionJson.conditionGroups.map(function (con, index) {
    return /*#__PURE__*/React.createElement(ConditionGroupEntry, {
      key: index,
      item: con
    });
  }))));
};